module.exports = __webpack_public_path__ + "img/spiral-details24.7aeec348.png";